import getLineHeightEm from './get-line-height-em';

const getResponsiveLineHeight = (fontSize, breakpoint) =>
  Math.round(getLineHeightEm(fontSize, breakpoint) * fontSize);

export default getResponsiveLineHeight;
